import {
    Snackbar as MuiSnackbar
} from '@mui/material'

import { forwardRef } from 'react'

import Styles from './style'

export const Snackbar = forwardRef((props, ref) => {
    const sx = {
        ...Styles.root,
        ...props.sx ?? {}
    }

    const open = props.config?.open ?? (props.open || false)
    const duration = props.config?.autoHideDuration ?? ( props.duration || props.autoHideDuration || null)
    const message = props.config?.message ?? (props.message || '')
    const position = props.config?.position ?? (props.position || props.anchorOrigin || { vertical: 'top', horizontal: 'right' })
    const onClose = props.config?.onClose ?? props.onClose

    return (
        <MuiSnackbar
            open={open}
            anchorOrigin={position}
            autoHideDuration={duration}
            message={message}
            onClose={onClose}
            {...props}
            sx={sx}
            ref={ref}
        >
            {props.children}
        </MuiSnackbar>
    )
})

Snackbar.displayName = 'Snackbar'

export default Snackbar